export default function RenderColor(value) {
    if (0 < parseFloat(value) && parseFloat(value) <= 0.5) {
      return '#ff0000';
    }
    if (0.5 < parseFloat(value) && parseFloat(value) <= 1.0) {
      return '#FF3D00';
    }
    if (1.0 < parseFloat(value) && parseFloat(value) <= 1.5) {
      return '#FF7900';
    }
    if (1.5 < parseFloat(value) && parseFloat(value) <= 2.0) {
      return '#FFB600';
    }
    if (2.0 < parseFloat(value) && parseFloat(value) <= 2.5) {
      return '#FFF200';
    }
    if (2.5 < parseFloat(value) && parseFloat(value) <= 3.0) {
      return '#B4D300';
    }
    if (3.0 < parseFloat(value) && parseFloat(value) <= 3.5) {
      return '#69B500';
    }
    if (3.5 < parseFloat(value) && parseFloat(value) <= 4.0) {
      return '#1E9600';
    }
  }
  